export const environment = {
  production: false,
  apiBaseUrl: 'https://api.staging.swipfx.com',
  baseUrl: "http://localhost:4200",
  pageSize: 10
};